/* eslint-disable no-unused-vars */
import React, { useEffect,useState } from "react";
import { useLocation, useNavigate } from "react-router";
import CustomTable from "../../../components/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import { Card, Button, Col, Row,Form, Modal,Upload,message,Input} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getPettyCashRequest } from "../../../@app/master/masterSlice";
import { baseURL } from "../../../api/baseURL";
import apis from "../../../api/stateAPI";
import messageToast from "../../../components/messageToast/messageToast";
import { useForm } from "react-hook-form";


function PettycashRequestPaymentRelease() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { 
    gettingPettyCashRequest,
    getPettyCashRequestResponse } = useSelector((state) => {
    return state.master;
  });

  const { state } = useLocation();
  let emp_date = localStorage.getItem("emp_code") || "";

  const data =
    getPettyCashRequestResponse?.length > 0
      ? (getPettyCashRequestResponse ?? []).map((e) => {
          let S_No = e.id;
          let Name = "";
          let Doc_No = e.doc_no;
          let Claim_Amount = e.request_amount;
          let Approved_Amount = e.approved_amount	;
          let Aging_Days = e.aging_days;
          let ticketstatus = e?.status;
          return {
            ...e,
            S_No,
            Name,
            Doc_No,
            Claim_Amount,
            Approved_Amount,
            Aging_Days,
            ticketstatus,
          };
        })
      : [];

  const navigate = useNavigate();

  const handleViewClick = (rowInfo) => {
     navigate("/pcrequestpaymentreleaseForm", {
      state: rowInfo,
    });
  };

  
  const [fileLists, setFileLists] = useState({});
  const [image, setImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewImage, setPreviewImage] = useState("");
  const handleChangenew = (info, rowKey) => {
    const { fileList } = info;
    setFileLists((prev) => ({ ...prev, [rowKey]: fileList }));   
    const imageUrl = info?.file?.response?.filename ?? "";  
    setImage((prev) => ({ ...prev, [rowKey]: imageUrl }));
    form.setFieldsValue({ [rowKey]: imageUrl });
  };

  const handlePreview = async (file) => {
    let src = file.url || file.preview;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    setPreviewImage(src);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const uploadButton = (
    <Button
      icon={<PlusOutlined />}
      style={{ display: "flex", flexDirection: "row" }}    
      className="orangeFactory"
      >
      <div style={{ marginLeft: "3px" }}>
        {state?.id ? "Upload" : "Upload"}
      </div>
    </Button>
  );

  // File Upload Props
  const props = {
    name: "image",
    action: `${baseURL}pettycash-payment-release-bo`,
    headers: { authorization: "authorization-text" }
  };
  const handleCancel = () => {
    setPreviewOpen(false);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    setPosition({
      x: e.clientX - startPosition.x,
      y: e.clientY - startPosition.y
    });
  };

  const handleMouseUp = () => setDragging(false);

  const [zoom, setZoom] = useState(1); // Initial zoom level
  const [position, setPosition] = useState({ x: 0, y: 0 }); // Track image position
  const [dragging, setDragging] = useState(false);
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const modalWidth = 430 * zoom;
  // Zoom Functions
  const zoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3)); // Max 3x zoom
  const zoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 1)); // Min 1x zoom

  // Drag Handlers
  const handleMouseDown = (e) => {
    setDragging(true);
    setStartPosition({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  const gridDatamonth = (data ?? []).map((e) => {
    return {
      ...e,
      month:e?.monthvalue,
    };});
  const [selected, updateSelected] = useState([]);

  const onChecked = (isChecked, audit_id) => {
    if (!isChecked) {
      selected.splice(selected.indexOf(audit_id), 1);
    } else {
      selected.push(audit_id)
    }
    updateSelected([...selected]);
  }

  function inArray(needle, haystack) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
      if (haystack[i] == needle) return true;
    }
    return false;
  }
  const { handleSubmit } = useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const currentDate = new Date().toISOString().split("T")[0]; 
  const [loading, setLoading] = useState(false);

  const onFinish = () => {
    const expenseIds = state?.expense_data?.map((item) => parseInt(item.id)) || [];
  
    let payment_release = gridDatamonth.filter((value) =>
      selected.includes(value.id) // Ensure `selected` contains valid IDs
    );  
    const payment_release_ids = payment_release.map((item) => parseInt(item.id));
  
    const data = {    
      id: payment_release_ids,
      expense_id: expenseIds, // Store only IDs
      payment_release_emp_code: emp_date,
      submission_date: currentDate,    
      payment_release_copy: image,
      status:
        state?.ticketstatus === "Waiting @ ORL Doc Submission"
          ? "Waiting @ ARM"
          : "Waiting @ ORL Doc Submission"
    };
  
    if (payment_release.length === 0) {
      messageApi.open({
        type: 'error',
        content: 'Please Select Outlet',
        className: 'custom-class',
        style: {
          marginTop: '40vh',
          color: '#d91616',
          fontWeight: 'bold'
        }
      });
      setLoading(false);
    } else {
      updateSelected(true);
      setLoading(true);
      apis.updatePettyCashRequestData(data).then((res) => {
        if (res.data?.status === 200) {         
          messageToast({
            message: res?.data?.statusText,
            status: res?.data?.status,
            title: "Payment Request"
          });        
          navigate(
            state?.ticketstatus === "Waiting @ ORL Doc Submission"
              ? "/paymentreleased"
              : "/paymentreleased"
          );
          setLoading(false);   
        }
      },1000);
    }
  };

 const handleReject = (e) => {  
  let payment_release = gridDatamonth.filter((value) =>
    selected.includes(value.id) // Ensure `selected` contains valid IDs
  );  
  const payment_release_ids = payment_release.map((item) => parseInt(item.id)); 
   let data = {
     id: payment_release_ids,
     submission_date: currentDate, 
     status:
       e?.ticketstatus == "Waiting @ BO Payment Release"
         ? "Waiting @ ARM"
         : "Back Office Rejected",    
     rejected_by:
       e?.ticketstatus == "Waiting @ BO Payment Release"
         ? "Back Office"
         : "BO",
   };
   apis.updatePettyCashRequestData(data).then((res) => {
     if (res.data?.status === 200) {      
        messageToast({
         message: res?.data?.statusText,
         status: res?.data?.status,
         title: "Payment Request",
       });
       if (state?.ticketstatus == "Waiting @ Back Office") {
         navigate("/orlpcclaimappbo");
       } else {
         navigate("/orlpcclaimapparm");
       }
     } else {
       messageToast({
         message: res?.data?.message ?? "Something went wrong",
         status: res?.data.status,
         title: "Payment Request",
       });
     }
   });  
  };



  const handleFormSubmit = () => {       
        dispatch(getPettyCashRequest({ emp_code: emp_date, type: "Waiting @ BO Payment Release"}));
      handleSubmit();
  };

  const [cashDetails, setCashDetails] = useState({});
  const [inhand, setInHand] = useState(0);
  const [yetConfirm, setYetConfirm] = useState(0);
  const [receiptConfirm, setReceiptConfirm] = useState(0);

  const getBalanceDetails = (emp_date) => {  
    let submitted = {
      emp_id: emp_date,
    };
    apis.getPettyBalRequest(submitted).then((res) => {
      // console.log(res,'res');
      if (res.data?.status === 200) {
        setInHand(res.data.balance_amount); 
        setYetConfirm(res.data.yet_confirm);
        setReceiptConfirm(res.data.receipt_confirm);   
      } 
    });
  };

  const paymentclick = (rowInfo) => {
    navigate("/paymentreleased", {});
  };

  const paymentRelease = (rowInfo) => {
    navigate("/pcrequestpaymentrelease", {});
  };

  useEffect(() => {
    dispatch(getPettyCashRequest({ emp_code: emp_date, type: "Waiting @ BO Payment Release" }));
    getBalanceDetails(emp_date); 
  }, [emp_date]);

  let column = [
    {
      key: '1', headerName: "Select", field: 'select', hide: false, width: 90, renderCell: (params) => {
        return <input type="checkbox" className="ms-2 mt-1" checked={selected.toString().includes(params.row.id)}  
                      onClick={(e) => 
                        onChecked(e.target.checked,params.row.id)                     
                      } />
      }, renderHeader: () => {
        return <div>
          <input type="checkbox" checked={gridDatamonth?.length === selected.length} className="ms-2 mt-1" onClick={(e) => {
            if (e.target.checked) {
              const selectedRowID = [...gridDatamonth.map((e) => e.id)];
              updateSelected(selectedRowID || [gridDatamonth?.push((e) => e.id)]);
              selected.push(e.id);
            } else {
              updateSelected([]);
            }
          }} />  
        </div>
        ;  
      },
    },
    { key: "2", headerName: "outletName", field: "outletName", hide: false, width: 300 },
    {
      key: "3",
      headerName: "Emp Code",
      field: "employee_code",
      hide: false,
      width: 100,
    },
    {
      key: "4",
      headerName: "Emp Name",
      field: "emp_name",
      hide: false,
      width: 200,
    },
  
    {
      key: "5",
      headerName: "Doc No",
      field: "Doc_No",
      hide: false,
      width: 240,
    },
    {
      key: "6",
      headerName: "Requested Amount",
      field: "Claim_Amount",
      hide: false,
      width: 150,
    },    
    {
      key: "7",
      headerName: "Approved Amount",
      field: "Approved_Amount",
      hide: false,
      width: 150,
    }, 
    {
      key: "8",
      headerName: "Bill Copy",
      field: "Bill_Copy",
      hide: false,
      width: 180,
      renderCell: (params) => {
        const rowKey = params.id;
        return (
          <>
            {" "}           
            <Upload
              {...props}
              style={{ width: "30px" }}
              fileList={fileLists[rowKey] || []}
              listType="picture-card"
              name="attachments" 
              onPreview={handlePreview}
              capture="environment"
              accept=".png,.jpg,.jpeg"
              onChange={(e) => handleChangenew(e, rowKey)}
              multiple
            >
              {fileLists[rowKey]?.length >= 1 ? null : uploadButton}
            </Upload>
            <Modal
              open={previewOpen}
              title={previewTitle}
              footer={null}
              onCancel={handleCancel}
              width={modalWidth}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  overflow: "hidden",
                  cursor: dragging ? "grabbing" : "grab"
                }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
              >
                <img
                  src={previewImage}
                  alt="example"
                  style={{
                    width: "100%",
                    transform: `scale(${zoom}) translate(${position.x}px, ${position.y}px)`,
                    transition: dragging ? "none" : "transform 0.3s ease"
                  }}
                />
              </div>
              <div style={{ marginTop: "10px", textAlign: "center" }}>
                <Button 
                    onClick={zoomIn} 
                    style={{ marginRight: "10px",backgroundColor: "#DAF7A6", color: "black" }}
                    className={`custom-background ${show ? "show" : ""}`}                                                 
                 >
                  Zoom In
                </Button>
                <Button 
                    onClick={zoomOut}
                    style={{ marginRight: "10px",backgroundColor: "#f0b27a", color: "black" }}
                    className={`custom-background ${show ? "show" : ""}`}>
                  Zoom Out
                </Button>
              </div>
            </Modal>
          </>
        );
      }
    },   
    {
      key: "10",
      headerName: "Expense Type",
      field: "expense_type",
      hide: false,
      width: 250,
      valueGetter: (params) => {
        const expenseType = params.row.expense_type || '';       
        return `${expenseType}`.trim(); // Combine and remove extra spaces
      }
    },
  
    {
      key: "11",
      headerName: "Remarks",
      field: "remark",
      hide: false,
      width: 250,
      valueGetter: (params) => {     
        const remarks = params.row.remark || '';
        return `${remarks}`.trim(); // Combine and remove extra spaces
      }
    },
    {
      key: "12",
      headerName: "Value",
      field: "amount",
      hide: false,
      width: 150,
      valueGetter: (params) => {     
        const amount = params.row.amount || '';
        return `${amount}`.trim(); // Combine and remove extra spaces
      }
    },
    {
      key: "13",
      headerName: "Aging Days",
      field: "Aging_Days",
      hide: false,
      width: 100,
    },
  ];
  return (
    <div className="h-screen apphide">
      {contextHolder}
      <Card>
        <Row>
          <Col span={24}>
            <Form
              name="basic"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}          
              autoComplete="off"            
            >               
            <Row>
            <Col md={{ span: 6 }} xs={{ span: 24 }}>
            <Form.Item name="Cash in Hand" label="Cash in Hand">
                      <Input
                        placeholder={
                          cashDetails?.emp_balance_amount
                            ? cashDetails?.emp_balance_amount
                            : inhand
                        }
                        disabled
                        name="Cash in Hand"
                      />
            </Form.Item>
            </Col>          
            <Col md={{ span: 6 }} xs={{ span: 24 }}>
                    <Form.Item
                      name="Receipt Confirmation"
                      label="Receipt Confirmation">
                      <Input
                        placeholder={
                          cashDetails?.approval_amount
                            ? cashDetails?.approval_amount
                            : receiptConfirm
                        }
                        disabled={true}
                        name="name"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={{ span: 6 }} xs={{ span: 24 }}>
                    <Form.Item
                      name="Yet to confirm by accounts "
                      label="Yet to confirm by accounts ">
                      <Input
                        placeholder={
                          cashDetails?.unapproveAmount
                            ? cashDetails?.unapproveAmount
                            : yetConfirm
                        }
                        disabled
                        name="Yet to confirm by accounts "
                      />
                    </Form.Item>
                  </Col>
            </Row>
            </Form>
          </Col>          
        </Row>
        <Row>
        <Col
           span={12}
           className="d-flex align-items-center justify-content-start mt-3">
           <Form.Item className="mx-2">
             <Button 
                onClick={paymentRelease}>                            
                Petty Cash Payment Release
             </Button>
           </Form.Item>        
           <Form.Item>
             <Button
                className="orangeFactory"
                onClick={paymentclick}>
                Payment Process
             </Button>
           </Form.Item>
          </Col>
        </Row>
      </Card>
      <CustomTable
        showHeader={false}
        showEdit={false}
        dataSource={gridDatamonth}
        key={column.id}
        column={column}
        loading={gettingPettyCashRequest}
      //  hideActionBtn={true}
        handleSubmit={handleFormSubmit}
        handleViewClick={handleViewClick}        
        title={"Approval List"}
      />
           <div
                className="d-flex justify-content-center align-items-center "
                style={{ width: "100%", padding: "1px" }}
              >
              <Form.Item>
                  <Button
                    onClick={handleSubmit(onFinish)}
                    loading={loading}
                    style={{
                      backgroundColor: "#34b1aa",
                      color: "white",
                      marginRight: "6px",
                      fontWeight: "bold"
                    }}
                    type="info"
                    htmlType="button"
                  >
                   Payment Release
                  </Button>
              </Form.Item>    
              <Form.Item>
                  <Button
                    onClick={handleReject}
                    loading={loading}
                    style={{
                      backgroundColor: "#fc1303",
                      color: "white",
                      marginRight: "6px",
                      fontWeight: "bold"
                    }}
                    type="info"
                    htmlType="button"
                  >
                   Payment Reject
                  </Button>
              </Form.Item>    
          </div> 
    </div>
  );
}

export default PettycashRequestPaymentRelease;
